import React from 'react'
import styles from './head-nav-link.styles'
import injectSheet from 'react-jss'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'

const HeadNavLink = ({ classes, children, path, location }) => (
  <li
    className={classNames(classes.item, {
      [classes.activeItem]: location.pathname === path
    })}>
    <Link className={classes.link} to={path}>
      {children}
    </Link>
  </li>
)

export default withRouter(injectSheet(styles)(HeadNavLink))
